


export const forecastTypes = {
  AGE: 2,
  ANNUAL_INCOME: 3,
  AFTER_TAX: 1,
}


// WEBPACK FOOTER //
// ./state/constants.js